import React from 'react';
import PropTypes from 'prop-types';
import ErrorBoundary from '../ErrorBoundary';
import Style from './Body.module.scss';

/**
 * Renderiza o componente Body.
 *
 * @param {Object} props - Propriedades do componente.
 * @param {React.ReactElement} props.children - Conteúdo renderizado dentro do componente.
 * @param {string} props.id - Identificador usado no elemento renderizado.
 * @param {Object} props.otherProps - Props adicionais repassadas para `otherProps`.
 * @returns {JSX.Element} Elemento renderizado pelo componente.
 */
const Body = props => {
    const { children, id, ...otherProps } = props;
    return (
        <ErrorBoundary>
            <div id={props.id} className={Style.root} {...otherProps}>
                {children}
            </div>
        </ErrorBoundary>
    );
};

Body.propTypes = {
    children: PropTypes.element
};

export default Body;
